/**
 * Created by lhzbxx on 2016/11/7.
 *
 * orders.js
 * 订单相关
 */

import * as types from '../mutation-types'
import orderApi from "../../api/order";
import http from "../../utils/fetch";

const state = {
  // info: {
  //   total: 0,
  //   page: 0
  // },
  savedItems: [],
  toPay: null,
  review: null,

  unReviewedCount: 0,
  unpaidCount: 0
}

const mutations = {

  [types.REMOVE_ORDER](state) {
    // state.info.total -= 1
    // window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },

  [types.REVIEW](state, product) {
    state.review = product
  },


  [types.SET_UNPAID_COUNT](state, count = 0){
    state.unpaidCount = count
  },
  [types.SET_UN_REVIEWED_COUNT](state, count = 0){
    state.unReviewedCount = count
  },
}

const actions = {
  async getOrders({commit, state}, {page, size, orderState}) {
    console.log('[orderState]', orderState)
    return await orderApi.getOrders(page, size, orderState)
  },
  getOrder (serialId) {
    return http.get({url: `orders/${serialId}`})
  },
  async fetchUnpaidCount ({commit}) {
    try {
      let unpaidCount = await orderApi.countUnpaid()
      commit(types.SET_UNPAID_COUNT, unpaidCount)
      return false
    }
    catch (error) {
      console.log(error)
    }
  },
  async fetchUnReviewedCount ({commit}) {
    try {
      let unpaidCount = await orderApi.countUnReviewed()
      commit(types.SET_UN_REVIEWED_COUNT, unpaidCount)
      return false
    }
    catch (error) {
      // Vue.tipError(error)
      console.log(error)
    }
  },
}

export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/module/order_list.js